module.exports = __webpack_public_path__ + "img/opex.7346e61c.svg";